const SDGSectionList =
[
  {
    key:['Q187'],
    description: "Does your company take actions to advance the Sustainable Development Goals(i.e. the Global Goals)?",
    optionMap: {
      '1': 'Yes',
      '2': 'No',

    }
  },
  {
    key:['Q114'],
    description: "Has your company conducted an assessment of risks and opportunities related to the Global Goals?",
    optionMap: {
      '4': 'Yes',
      '5': 'No',

    }
  },

  // Q115
  {
    key:['Q115_6'],
    description: "From your perspective, what would you say is your company's current impact on Goal 1. No poverty?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_7'],
    description: "From your perspective, what would you say is your company's current impact on Goal 2. Zero hunger?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_8'],
    description: "From your perspective, what would you say is your company's current impact on Goal 3. Good Health and Well-Being?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_9'],
    description: "From your perspective, what would you say is your company's current impact on Goal 4. Quality Education?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_10'],
    description: "From your perspective, what would you say is your company's current impact on Goal 5. Gender equality?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_11'],
    description: "From your perspective, what would you say is your company's current impact on Goal 6. Clean water and sanitation?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_12'],
    description: "From your perspective, what would you say is your company's current impact on Goal 7. Affordable and clean energy?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_13'],
    description: "From your perspective, what would you say is your company's current impact on Goal 8. Decent Work and Economic Growth?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_14'],
    description: "From your perspective, what would you say is your company's current impact on Goal 9. Industry, Innovation and Infrastructure?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_15'],
    description: "From your perspective, what would you say is your company's current impact on Goal 10.  Reduce inequalities?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_16'],
    description: "From your perspective, what would you say is your company's current impact on Goal 11. Sustainable Cities and Communities?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_17'],
    description: "From your perspective, what would you say is your company's current impact on Goal 12. Responsible Consumption and Production?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_18'],
    description: "From your perspective, what would you say is your company's current impact on Goal 13. Climate action?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_19'],
    description: "From your perspective, what would you say is your company's current impact on Goal 14. Life below Water?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_20'],
    description: "From your perspective, what would you say is your company's current impact on Goal 15. Life on Land?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_21'],
    description: "From your perspective, what would you say is your company's current impact on Goal 16. Peace, Justice and Strong Institutions?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },
  {
    key:['Q115_22'],
    description: "From your perspective, what would you say is your company's current impact on Goal 17. Partnerships for the Goals?",
    optionMap: {
      '1': 'Significant negative impact',
      '2': 'Somewhat negative impact',
      '3': 'Somewhat positive impact',
      '4': 'Significant positive impact',

    }
  },


  {
    key:['Q93'],
    multiselect: true,
    SDGColor: true,
    description: "Which of the following Global Goals does your company currently target?",
    optionMap: {
      '1': 'Goal 1. No poverty',
      '2': 'Goal 2. Zero hunger',
      '3': 'Goal 3. Good Health and Well-Being',
      '4': 'Goal 4. Quality Education',
      '5': 'Goal 5.  Gender equality',
      '6': 'Goal 6. Clean water and sanitation',
      '7': 'Goal 7. Affordable and clean energy',
      '8': 'Goal 8. Decent Work and Economic Growth',
      '9': 'Goal 9. Industry, Innovation and Infrastructure',
      '10': 'Goal 10.  Reduce inequalities',
      '11': 'Goal 11. Sustainable Cities and Communities',
      '12': 'Goal 12: Responsible Consumption and Production',
      '13': 'Goal 13. Climate action',
      '14': 'Goal 14. Life below Water',
      '15': 'Goal 15. Life on Land',
      '16': 'Goal 16. Peace, Justice and Strong Institutions',
      '17': 'Goal 17: Partnerships for the Goals',
      '18': 'Other',
      '19': 'Unsure',

    }
  },


  {
    key:['Q345'],
    multiselect: true,
    description: "How does your company take action to contribute to the Global Goals?",
    optionMap: {
      // '1': "aaa",
      '2': "Upholding the Ten Principles of the UN Global Compact",
      '3': "Align core business strategy with the Goals",
      '4': "Develop products and/or services that contribute to the Goals",
      '5': "Design business models that contribute to the Goals",
      '6': "Set corporate goals that are sufficiently ambitious, science-based and/or align with societal needs",
      // '7': "Social investment and philanthropy",
      '8': "Voluntary financial contributions to charitable and/or non-profit organizations",
      '9': "Voluntary non-financial/in-kind contributions to charitable and/or non-profit organizations",
      // '10': "Advocacy",
      '11': "Publicly advocate the importance of action in relation to the Goals",
      '12': "Participate in key summits and other important public policy interactions in relation to the Goals",
      '13': "Publicly communicate/disclose your Global Goal practices and impacts",
      // '14': "Collaboration and Partnerships",
      '15': "Engage in partnership projects with public or private organizations",
      '16': "Participate in industry collaboration to advance the Goals",
      //
    }
  }




]

export {SDGSectionList};



// WEBPACK FOOTER //
// ./src/App/data/SDGSectionList.js